export function formatMigrationShort(version) {
  if (!version) return "unknown";
  const clean = String(version).trim();
  return clean ? clean.slice(-6) : "unknown";
}

export function getReleaseSyncState({ expectedMigration, databaseMigration, loading, error }) {
  if (loading) {
    return {
      tone: "checking",
      label: "DB checking",
      title: "Checking the database migration version for this app build.",
    };
  }

  if (error || !databaseMigration) {
    return {
      tone: "unknown",
      label: "DB unknown",
      title: "Could not confirm the database migration version for this app build.",
    };
  }

  if (String(databaseMigration) === String(expectedMigration)) {
    return {
      tone: "synced",
      label: `DB ${formatMigrationShort(databaseMigration)} synced`,
      title: `Database migration ${databaseMigration} matches this app build.`,
    };
  }

  const isBehind = String(databaseMigration) < String(expectedMigration);
  return {
    tone: isBehind ? "behind" : "ahead",
    label: `DB ${formatMigrationShort(databaseMigration)} ${isBehind ? "behind" : "ahead"}`,
    title: `Database migration ${databaseMigration} is ${isBehind ? "behind" : "ahead of"} this app build. Expected ${expectedMigration}.`,
  };
}
